/** @jsxImportSource theme-ui @jsxRuntime classic */
import { H } from '@hzdg/sectioning';
import * as Icons from '@tishman/icons';
import React from 'react';

import { Box, Flex, Text, HistoryCardProps, useThemeUI } from '..';

export const HearHistoryCard = ({
  hearHistory,
}: Pick<HistoryCardProps, 'hearHistory'>): JSX.Element => {
  const themeUI = useThemeUI();
  return (
    <Box
      sx={{
        textAlign: ['center', null, 'left'],
        maxWidth: '300px',
        mx: 'auto',
        mt: [4, null, 6],
      }}
    >
      <Flex
        sx={{
          alignItems: 'center',
          justifyContent: 'flex-start',
          mb: 3,
        }}
      >
        <Icons.Volume style={{ marginRight: themeUI.theme.space[3] }} />
        <H
          sx={{
            variant: 'styles.h4',
            fontFamily: 'headingSecondary',
            mb: 0,
          }}
        >
          Hear History
        </H>
      </Flex>
      <Text
        as="p"
        sx={{
          variant: 'text.smallP',
          fontStyle: 'italic',
        }}
      >
        {hearHistory}
      </Text>
    </Box>
  );
};
